import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { CredentialsService } from '@core/services/credentials.service';
import { Logger } from '@core/services/logger.service';

const log = new Logger('AuthenticationGuard');

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  constructor(private router: Router, private credentialsService: CredentialsService) {
     // This is intentional
  }

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
    if (this.credentialsService.isAuthenticated()) {
      return true;
    }
    log.debug('Not authenticated, redirecting and adding redirect url...');
    this.router.navigate(['/login']);
    return false;
  }
}
